import { render, staticRenderFns } from "./game-card.vue?vue&type=template&id=068fdd40&scoped=true&"
import script from "./game-card.vue?vue&type=script&lang=js&"
export * from "./game-card.vue?vue&type=script&lang=js&"
import style0 from "./game-card.vue?vue&type=style&index=0&id=068fdd40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fdd40",
  null
  
)

export default component.exports